import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { id: "top" }, null, -1)
const _hoisted_2 = {
  key: 0,
  class: "app-container"
}
const _hoisted_3 = { class: "app-loading" }
const _hoisted_4 = { class: "container scroll" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("i", {
  class: "fa fa-chevron-up",
  "aria-hidden": "true"
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]

import { ComputedRef, computed, ref, onBeforeMount, onMounted } from 'vue'

  import Footer from '@/components/Footer.vue'
  import NavBar from '@/components/NavBar.vue'
  import NoConfig from '@/components/NoConfig.vue'
  import { ROOT_STORE } from '@/store/constants'
  import { TAppConfig } from '@/types/application'
  import { useStore } from '@/use/useStore'

  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const store = useStore()

  const appConfig: ComputedRef<TAppConfig> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_CONFIG]
  )
  const appLoading: ComputedRef<boolean> = computed(
    () => store.getters[ROOT_STORE.GETTERS.APP_LOADING]
  )
  const hideScrollBar = ref(false)
  const displayScrollButton = ref(false)

  onBeforeMount(() => store.dispatch(ROOT_STORE.ACTIONS.GET_APPLICATION_CONFIG))
  onMounted(() => scroll())

  function updateHideScrollBar(isMenuOpen: boolean) {
    hideScrollBar.value = isMenuOpen
  }
  function isScrolledToBottom(element: Element): boolean {
    return (
      element.getBoundingClientRect().top < window.innerHeight &&
      element.getBoundingClientRect().bottom >= 0
    )
  }
  function scroll() {
    window.onscroll = () => {
      let bottom = document.querySelector('#bottom')
      displayScrollButton.value = bottom !== null && isScrolledToBottom(bottom)
    }
  }
  function scrollToTop() {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
    setTimeout(() => {
      displayScrollButton.value = false
    }, 300)
  }

return (_ctx: any,_cache: any) => {
  const _component_Loader = _resolveComponent("Loader")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(NavBar, { onMenuInteraction: updateHideScrollBar }),
    (_unref(appLoading))
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_Loader)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: _normalizeClass(["app-container", { 'hide-scroll': hideScrollBar.value }])
        }, [
          (_unref(appConfig))
            ? (_openBlock(), _createBlock(_component_router_view, { key: 0 }))
            : (_openBlock(), _createBlock(NoConfig, { key: 1 }))
        ], 2)),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("div", {
        class: _normalizeClass(["scroll-button", { 'display-button': displayScrollButton.value }]),
        onClick: scrollToTop
      }, _hoisted_6, 2)
    ]),
    (_unref(appConfig))
      ? (_openBlock(), _createBlock(Footer, {
          key: 2,
          version: _unref(appConfig) ? _unref(appConfig).version : '',
          adminContact: _unref(appConfig).admin_contact
        }, null, 8, ["version", "adminContact"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})